import { css } from '@emotion/css';
import classNames from 'classnames';
import { colors } from 'constants/theme';
import { useEffect, useState } from 'react';
import { cloneObject } from 'utils/function';

let interfaceTable: string[][] = [[], [], [], [], [], [], [], [], [], []];
interface Props {
    resultList: string[];
    methodid: number;
    onHover?: (list: string[]) => void;
    borderColor?: string;
}

const checkIs2SoDau = (methodId: number) => {
    return methodId.toString().slice(-3) === '145' || methodId.toString().slice(-3) === '146'; // lo 2 so dau vs lo 2 so dau 1k
};

function TableLotteryDauDuoi(props: Props) {
    const { resultList, methodid, onHover, borderColor } = props;
    const [tableList, setTableList] = useState<string[][]>([]);
    useEffect(() => {
        let tmpList: string[] = [];
        resultList.forEach((num) => {
            if (checkIs2SoDau(methodid)) {
                if (num.length > 2) {
                    tmpList.push(num.slice(0, 1));
                }
            } else {
                tmpList.push(num.slice(-2));
            }
        });
        let newTableList = cloneObject(interfaceTable);

        tmpList.forEach((item) => {
            const dauDuoi = item.split('');
            newTableList[Number(dauDuoi[0])].push(dauDuoi[1]);
        });
        setTableList(newTableList);
        return () => {
            interfaceTable = [[], [], [], [], [], [], [], [], [], []];
            tmpList = [];
            newTableList = [];
        };
    }, [resultList, methodid]);

    const handleHover = (dau: number, listDuoi: string[]) => {
        const listNumHover = listDuoi.map((duoiItem) => `${dau}${duoiItem}`);
        if (onHover) {
            onHover(listNumHover);
        }
    };
    const handleBlur = () => {};

    return (
        <div className={styles.wrap} style={{ borderColor }}>
            <div className={`${styles.row} ${styles.rowHeading}`}>
                <p className={`${styles.label} ${styles.title}`}>Đầu</p>
                <p className={styles.title}>Đuôi</p>
            </div>
            {tableList.map((group, index) => (
                <div
                    className={classNames(styles.row, index % 2 === 1 ? styles.background2 : styles.background1)}
                    key={index}
                    onMouseEnter={() => handleHover(index, group)}
                    onMouseLeave={() => handleBlur()}
                >
                    <p className={styles.label}>{index}</p>
                    <p className={styles.group}>{group.join(',')}</p>
                </div>
            ))}
        </div>
    );
}

const styles = {
    wrap: css`
        min-width: 150px;
        display: flex;
        flex-direction: column;
    `,
    row: css`
        display: flex;

        &:last-child {
            border-bottom: none;
        }
        p {
            text-align: center;
            align-self: center;
            &:last-child {
                flex: 1;
            }
        }
    `,
    background1: css`
        background-color: #330000;
    `,
    background2: css`
        background-image: linear-gradient(to bottom, #5b1313, #931f1f);
    `,
    group: css`
        color: #e7dbc3;
    `,
    rowHeading: css`
        background: white;
        height: 30px;
        background-color: white;
        border: 1px solid black;
        border-left: 0;
    `,
    label: css`
        flex: 0 0 50px;
        border-right: 1px solid ${colors.borderTable};
        line-height: 27.9px;
        color: #e7dbc3;
    `,
    title: css`
        color: ${colors.black};
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 300;
        font-size: 15px;
    `,
};

export default TableLotteryDauDuoi;
